var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CardList',{attrs:{"list":_vm.list,"type":"other","showModel":"home","isShowLoading":_vm.isShowLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }